import type { QueryClient } from '@tanstack/react-query'
import type Pusher from 'pusher-js'

const GLOBAL_MESSAGES_CHANNEL = 'global-messages'
const GLOBAL_MESSAGES_UPDATED_EVENT = 'updated'
const MAX_REFETCH_DELAY_MS = 30_000

export const subscribeToGlobalMessages = (
  pusher: Pusher,
  queryClient: QueryClient
): void => {
  pusher
    .subscribe(GLOBAL_MESSAGES_CHANNEL)
    .bind(GLOBAL_MESSAGES_UPDATED_EVENT, () => {
      setTimeout(() => {
        void queryClient.invalidateQueries({
          queryKey: ['config', 'organization.global_messages']
        })
      }, Math.random() * MAX_REFETCH_DELAY_MS)
    })
}
